



























import Vue from 'vue'
import axios from 'axios'
import Component from 'vue-class-component'
import CoreList from '../../core/components/list/index.vue'

import RemoveConfirmModal from '../components/RemoveConfirmModal.vue'
import { dispatchErrorMessage } from '../../core/utils'

@Component({
  components: {
    CoreList,
    RemoveConfirmModal
  }
})
export default class EmailTemplateList extends Vue {
  breadcrumbs = [{ text: 'Email Templates', url: '/admin/emails/templates' }]

  filterOptions = [
    { text: 'ID', key: 'id', type: 'number' },
    { text: 'Subject', key: 'name', type: 'string'},
  ]

  availableColumns = [
    { text: 'ID', value: 'id' },
    { text: 'Subject', value: 'name' },
    { text: 'Status', value: 'status', display: (data: string) => data === 'active' ? 'Active' : 'Disabled' }
  ]

  defaultColumns = ['id', 'name', 'status']

  actions =  [
    { text: 'View', method: this.renderItem },
    { text: 'Disable', method: this.disableItem, visible: (item: any) => item.status === 'active' },
    { text: 'Enable', method: this.enableItem, visible: (item: any) => item.status === 'disabled' },
    { text: 'Remove', method: this.confirmRemoveItem, visible: (item: any) => item.status === 'disabled' }
  ]

  get removeConfirm() {
    return this.$refs.removeConfirm as RemoveConfirmModal
  }

  public renderItem(item: any) {
    this.$router.push(`/admin/emails/templates/${item.id}`)
  }

  public disableItem(item: any) {
    axios.patch(`emails/templates/${item.id}/disable`).then((response) => {
      (this.$refs.list as any).updateResults()
      this.$store.dispatch('showSuccess', 'Template disabled!')
    }).catch((err) => {
      
    })
  }

  public enableItem(item: any) {
    axios.patch(`emails/templates/${item.id}/enable`).then((response) => {
      (this.$refs.list as any).updateResults()
      this.$store.dispatch('showSuccess', 'Template enabled!')
    })
  }

  public confirmRemoveItem(item: any) {
    this.removeConfirm.open(item)
  }

  public removeItem(item: any) {
    axios.delete(`emails/templates/${item.id}`).then((response) => {
      (this.$refs.list as any).updateResults()
      this.$store.dispatch('showSuccess', 'Template removed!')
    }).catch(error => {
      dispatchErrorMessage(error, this.$store.dispatch)
    })
  }
}
